<forge-scaffold>
    <div slot="body" style="height: 100%; min-height: 70vh;">
        @if (loading) {
        <busy-indicator [page]="true"></busy-indicator>
        }

        @if (showViewer) {
        <iframe fxFlex="auto" style="border: none;" id="embeddedPage" [attr.data-hash]="hashId"></iframe>
        }

        @if (tcm && !hasTcmPermission) {
        <div>
            <div class="forge-typography--heading2">
                You do not have permission for TCM. Please contact an administrator.
            </div>
        </div>
        }
    </div>

    @if (!loading && !tcm && !hideFooter) {
    <div slot="body-footer" fxLayout="row" fxLayoutAlign="end center"
        class="metadata-form--footer form-actions-container">
        <forge-button [dense]="compactMode" variant="outlined" (click)="close()" telemetry="Submission-Close Document"
            tabindex="0">
            Close
        </forge-button>
        @if (allowEmail) {
        <forge-split-button [dense]="compactMode" variant="raised" theme="primary">
            <forge-button [dense]="compactMode" variant="raised" attr.telemetry="Submission-{{currentCompoundOption}}"
                (click)="compoundAction()">
                {{currentCompoundOption}}
            </forge-button>
            <forge-menu [options]="compoundOptions" placement="top-end" highlight-first="false" [dense]="compactMode"
                (forge-menu-select)="compoundAction($event)" (forge-menu-open)="menuOpened($event)">
                <forge-button [dense]="compactMode" variant="raised" aria-label="Save-keyboard_arrow_down">
                    <forge-icon name="keyboard_arrow_down"></forge-icon>
                </forge-button>
            </forge-menu>
        </forge-split-button>
        }
        @if (!allowEmail) {
        <forge-button [dense]="compactMode" variant="raised" (click)="download()" telemetry="Submission-Download"
            tabindex="0" class="metadata-form--footer-button">
            Download
        </forge-button>
        }
    </div>
    }
</forge-scaffold>